/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { StoreProfileStoreDetails } from './StoreProfileStoreDetails';
import {
    StoreProfileStoreDetailsFromJSON,
    StoreProfileStoreDetailsFromJSONTyped,
    StoreProfileStoreDetailsToJSON,
    StoreProfileStoreDetailsToJSONTyped,
} from './StoreProfileStoreDetails';

/**
 * 
 * @export
 * @interface DraftDetails
 */
export interface DraftDetails {
    /**
     * 
     * @type {string}
     * @memberof DraftDetails
     */
    id: string;
    /**
     * 
     * @type {Date}
     * @memberof DraftDetails
     */
    createdAt?: Date;
    /**
     * 
     * @type {Date}
     * @memberof DraftDetails
     */
    updatedAt?: Date;
    /**
     * 
     * @type {StoreProfileStoreDetails}
     * @memberof DraftDetails
     */
    store: StoreProfileStoreDetails;
}

/**
 * Check if a given object implements the DraftDetails interface.
 */
export function instanceOfDraftDetails(value: object): value is DraftDetails {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('store' in value) || value['store'] === undefined) return false;
    return true;
}

export function DraftDetailsFromJSON(json: any): DraftDetails {
    return DraftDetailsFromJSONTyped(json, false);
}

export function DraftDetailsFromJSONTyped(json: any, ignoreDiscriminator: boolean): DraftDetails {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'createdAt': json['createdAt'] == null ? undefined : (new Date(json['createdAt'])),
        'updatedAt': json['updatedAt'] == null ? undefined : (new Date(json['updatedAt'])),
        'store': StoreProfileStoreDetailsFromJSON(json['store']),
    };
}

export function DraftDetailsToJSON(json: any): DraftDetails {
    return DraftDetailsToJSONTyped(json, false);
}

export function DraftDetailsToJSONTyped(value?: DraftDetails | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'createdAt': value['createdAt'] == null ? value['createdAt'] : value['createdAt'].toISOString(),
        'updatedAt': value['updatedAt'] == null ? value['updatedAt'] : value['updatedAt'].toISOString(),
        'store': StoreProfileStoreDetailsToJSON(value['store']),
    };
}

